module.exports = __webpack_public_path__ + "static/media/video_4.5c8d1728.png";